import {
  HierarchyCard,
  Icon,
  Text,
  useIsMobile
} from '@yes.technology/react-toolkit'
import {
  ContentWrapper,
  PlayButton,
  PlayButtonContainer
} from './AnimationSlider.styles'
import { SafeHtmlContent } from 'site/shared/components/SafeHtmlContent'
import { useState } from 'react'

type StarterPopupProps = {
  onClick: () => void
  des: string
  complement: string
  color?: string
}

const StarterPopup = ({
  onClick,
  des,
  complement,
  color
}: StarterPopupProps) => {
  const isMobile = useIsMobile()

  const [isAnimationStarted, setIsAnimationStarted] = useState(false)

  const handleClick = () => {
    setIsAnimationStarted(true)
    onClick()
  }

  return (
    <ContentWrapper animationStarted={isAnimationStarted}>
      <HierarchyCard spacingClass='doubleXLarge'>
        <Text
          variant={isMobile ? 'content-emphasis-04' : 'content-emphasis-06'}
          as='h2'
        >
          {des}
        </Text>
        <Text variant={isMobile ? 'content-03' : 'bordertext-05'}>
          <SafeHtmlContent html={complement} />
        </Text>
        <PlayButtonContainer>
          <PlayButton onClick={handleClick} color={color}>
            <Icon iconName='Play' icSize='large' icColor='white' />
          </PlayButton>
        </PlayButtonContainer>
      </HierarchyCard>
    </ContentWrapper>
  )
}

export default StarterPopup
